function _(e,r,s){var a=e(515);s.Tables=a,e(108).register_models(a)}
//# sourceMappingURL=main.min.js.map